export default {
  BEGIN: "begin",
  MID: "mid",
  END: "end"
};
